import React from 'react';

import {
  ContentCarouselBlock,
  FeatureSummary,
  PageContactSupport,
  ProductSummary,
  ProductType,
  ProductVariant,
  TextIconList,
  VideoImageRenderer,
  MasterTextBlock,
  ProductCarousel,
  MultiColumnBanner,
  DocumentBlock,
  HeroBannerCarousel,
  LogoWall,
  ProductSlideshow,
  AskGregSectionRenderer,
  HeadlineRenderer,
  QuoteRenderer,
  MilestoneRenderer,
  Gallery,
} from '.';

import { ImageGrid } from './ImagesGrid';
import { Newsletter } from './Newsletter';
import { ImageTextBlock } from './ImageTextBlock';
import { Applications } from './PageApplications';
import { MiddleBanner } from './MiddleBanner';
import { TextSection } from './TextSection';
import { ContactFormBlock } from './ContactFormBlock';

type BlocksType = {
  [key: string]: React.ComponentType<any>;
};

type BlockType = {
  _type: string;
  _key: string;
};

type BlockProps = {
  index: number;
  block: BlockType;
  pageId: string;
  pageType: string;
};

const Blocks: BlocksType = {
  textSection: TextSection,
  imageTextBlock: ImageTextBlock,
  documentBlock: DocumentBlock,
  gallery: Gallery,
  imageGrid: ImageGrid,
  productSummary: ProductSummary,
  applicationsBlock: Applications,
  contactSupportBlock: PageContactSupport,
  // heroBannerBlock: HeroBannerBlock,
  productVariantSection: ProductVariant,
  middleBanner: MiddleBanner,
  featureSummary: FeatureSummary,
  productType: ProductType,
  videoImageBlock: VideoImageRenderer,
  contentCarousel: ContentCarouselBlock,
  heroBannerSlideshow: HeroBannerCarousel,
  textIconList: TextIconList,
  masterTextBlock: MasterTextBlock,
  productSlideshow: ProductSlideshow,
  productCarousel: ProductCarousel,
  multiColumnBanner: MultiColumnBanner,
  headline: HeadlineRenderer,
  milestoneTimeline: MilestoneRenderer,
  quote: QuoteRenderer,
  logoWall: LogoWall,
  askGreg: AskGregSectionRenderer,
  newsletter: Newsletter,
  contactFormBlock: ContactFormBlock,
};

/**
 * Used by the <PageBuilder>, this component renders a the component that matches the block type.
 * Automatically applies stega cleaning to all block data for live preview compatibility.
 */
export default function BlockRenderer({ block, index }: BlockProps) {
  if (!block || !block._type) return null;

  const blockType = typeof block._type === 'string' ? (block._type.split('.').pop() ?? block._type) : block._type;

  // Block does exist
  if (typeof Blocks[blockType] !== 'undefined') {
    return (
      <div key={block._key}>
        {React.createElement(Blocks[blockType], {
          key: block._key,
          block,
          index: index,
        })}
      </div>
    );
  }
  // Block doesn't exist yet
  return React.createElement(
    () => (
      <div className="w-full bg-secondary-100 text-center text-secondary-50 p-20 rounded">
        A &ldquo;{block._type}&rdquo; block hasn&apos;t been created
      </div>
    ),
    { key: block._key },
  );
}
